import AddGroupModal from './AddGroupModal'
import EditGroupModal from './EditGroupModal'
import AddPolicyForm from '../AddPolicyForm'
import AddUsersForm from '../AddUsersForm'
import RemoveUserModal from './RemoveUserModal'
import RemovePolicyModal from './RemovePolicyModal'
import RemoveGroupModal from './RemoveGroupModal'

import { User, ResourcePolicy, Group } from 'graphql'
import { heapEvent } from '@equipmentshare/heaper'
import { Group as MinimalGroup } from '../../index'

export function getAddGroupModal( onSuccess: () => void ) {
	return {
		component: AddGroupModal,
		label: 'Add Group',
		onSuccess,
		onXClick: () => heapEvent( 'Inventory - Add Group Modal - Click - X button', {} ),
	}
}

export function getEditGroupModal( selectedGroup: MinimalGroup, onDeleteClick: () => void ) {
	return {
		component: EditGroupModal,
		componentProps: {
			selectedGroup,
			onDeleteClick,
		},
		label: 'Edit Group',
		onXClick: () => heapEvent( 'Inventory - Edit Group Modal - Click - X button', {} ),
	}
}

export function getRemoveGroupModal( group: MinimalGroup, onSuccess: () => void ) {
	return {
		component: RemoveGroupModal,
		componentProps: { group },
		label: 'Remove Group',
		onSuccess,
		onXClick: heapEvent( 'Inventory - Remove Group Modal - Click - X button', {} ),
	}
}

export function getAddPolicyModal( group: Group, onConfirm: () => void ) {
	return {
		component: AddPolicyForm,
		componentProps: { group, onConfirm },
		label: 'Add Policy',
		onXClick: () => heapEvent( 'Inventory - Add Policy to Group Modal - Click - X button', {} ),
	}
}

export function getAddUsersModal( selectedGroup: Group, onConfirm: () => void ) {
	return {
		component: AddUsersForm,
		componentProps: { selectedGroup, onConfirm },
		label: 'Add Users to Group',
		onXClick: heapEvent( 'Inventory - Add Users to Group Modal - Click - X button', {} ),
	}
}

export function getRemoveUserModal( user: User, group: Group, onConfirm: () => void ) {
	return {
		component: RemoveUserModal,
		componentProps: { user, group, onConfirm },
		label: 'Remove User from Group',
		onXClick: heapEvent( 'Inventory - Remove User From Group Modal - Click - X button', {} ),
	}
}

export function getRemovePolicyModal( policy: ResourcePolicy, group: Group, onConfirm: () => void ) {
	return {
		component: RemovePolicyModal,
		componentProps: { policy, group, onConfirm },
		label: 'Remove Policy from Group',
		onXClick: heapEvent( 'Inventory - Remove Policy From Group Modal - Click - X button', {} ),
	}
}
